<template>
  <section class="hero is-light is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="error has-text-centered">
              <b-taglist attached>
                <b-tag type="is-dark" size="is-large">😔</b-tag>
                <b-tag type="is-primary" size="is-large">¯\_(ツ)_/¯</b-tag>
              </b-taglist>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'NotFoundComponent',
    methods: {
      showAlert(){
        this.$buefy.dialog.alert({
          title: 'Ein Fehler ist aufgetreten.',
          message: 'Diese Seite existiert leider nicht.',
          type: 'is-warning',
          hasIcon: true,
          icon: 'comment-exclamation',
          iconPack: 'fad',
          ariaRole: 'alertdialog',
          ariaModal: true,
          confirmText: 'Zur Eventübersicht',
          onConfirm: () => this.$router.push({name: 'home'})
        })
      }
    },
    mounted() {
      this.showAlert()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .error .tags{
  justify-content: center;
  }
  .modal-background{
    background-color: #d2d2d2;
  }
</style>
